export const PIN_MAX_LENGTH = 6;

export function competitionJudgePinLoginPath(
  eventId: string,
  judgeNumber: 1 | 2 | 3,
): string {
  return `/competition/judge-login/${eventId}/${judgeNumber}`;
}

export const PIN_KEYPAD: { id: string; value: string }[] = [
  { id: "k1", value: "1" },
  { id: "k2", value: "2" },
  { id: "k3", value: "3" },
  { id: "k4", value: "4" },
  { id: "k5", value: "5" },
  { id: "k6", value: "6" },
  { id: "k7", value: "7" },
  { id: "k8", value: "8" },
  { id: "k9", value: "9" },
  { id: "spacer", value: "" },
  { id: "k0", value: "0" },
  { id: "kdel", value: "⌫" },
];
